import { lazy } from 'react';

export const TopicPageAsync = lazy(async () => import('./TopicPage'));
